// Cuenta corriente — algoritmo original, extraído sin modificar de js/cuenta-corriente.js.
// Es el único que produce un código alfanumérico de 8 caracteres, armado carácter
// a carácter recorriendo hacia atrás una cadena de dígitos.
// Verificado contra tools/caracterizacion/golden.json.

// Tope de iteraciones del bucle, tal como estaba en el original.
const MAX_PASADAS = 1500;

export function validar({ fecha }) {
  if (!fecha || String(fecha).trim() === '') {
    return 'Falta la fecha';
  }
  return null;
}

export function calcular({ sucursal, fecha, cliente, tipoDocumento, importe }) {
  const Sucursal = parseInt(sucursal, 10);
  const Cliente = parseInt(cliente, 10);
  const Importe = parseInt(importe, 10);
  const Documento = String(tipoDocumento);

  const FechaSep = String(fecha).split('-');
  const Dia = parseInt(FechaSep[0], 10);
  const Mes = parseInt(FechaSep[1], 10);
  const Anio = parseInt(FechaSep[2], 10);

  let posic = 15;
  let V2 = Cliente;
  let Resultado = (Importe <= 9999 ? Importe * 785 : Importe);

  if (Dia % 2 == 0) {
    Resultado += Dia * 3 * 1000000;
  } else {
    Resultado += Dia * 2 * 1000000;
  }

  if (Mes % 2 == 0) {
    Resultado += Mes * 4 * 1000;
  } else {
    Resultado += Mes * 5 * 1000;
  }

  Resultado += Anio * Sucursal;

  while (Resultado > 99999999) {
    Resultado = parseInt(Resultado / 1.7, 10);
  }

  // substring(1, 0) equivale a substring(0, 1): JS ordena los argumentos.
  if (Cliente % 2 == 0) {
    V2 += parseInt(Documento.substring(1, 0).charCodeAt(0)) * 100000;
    V2 += parseInt(Documento.substring(2, 1).charCodeAt(0)) * 1000;
    V2 += parseInt(Documento.substring(3, 2).charCodeAt(0)) * 10;
  } else {
    V2 += parseInt(Documento.substring(3, 2).charCodeAt(0)) * 100000;
    V2 += parseInt(Documento.substring(1, 0).charCodeAt(0)) * 1000;
    V2 += parseInt(Documento.substring(2, 1).charCodeAt(0)) * 10;
  }

  while (V2 > 99999999) {
    V2 = parseInt(V2 / 1.4, 10);
  }

  let V1 = '' + Resultado;
  V1 = '00000000'.substring(0, 8 - V1.toString().length) + V1.toString();
  V1 += '00000000'.substring(0, 8 - V2.toString().length) + V2.toString();
  V2 = V1.substring(posic - 1, posic - 1 + 2);
  V2 = parseInt(V2, 10);

  let codigo = '';
  let pasadas = 0;
  let truncado = false;

  while (codigo.length < 8) {
    pasadas += 1;
    if (pasadas > MAX_PASADAS) {
      truncado = true;
      break;
    }
    if (V2 == 0) {
      V2 = Dia;
      continue;
    }

    if (V2 <= 12) {
      V2 += Math.round(V2 * 4.75);
      continue;
    }

    if (V2 <= 24) {
      V2 += Math.round(V2 * 2.33);
      continue;
    }

    if (V2 <= 36) {
      V2 += parseInt(V2 / 2.18, 10);
      continue;
    }

    if (V2 < 48) {
      V2 += parseInt(V2 / 3.33, 10);
      continue;
    }

    if ((V2 >= 48 && V2 <= 57) || (V2 >= 65 && V2 <= 90)) {
      codigo += String.fromCharCode(V2);
      posic -= 2;
      V2 = V1.substring(posic - 1, posic - 1 + 2);
      V2 = parseInt(V2, 10);
      continue;
    }

    if (V2 < 65) {
      V2 += parseInt(V2 / 3.23, 10);
      continue;
    }

    if (V2 > 90 && V2 < 100) {
      V2 = (V2 % 90) + Math.round(V2 * 7.43);
      V2 = parseInt(V2, 10);
      continue;
    }

    V2 = (V2 % 100);
  }

  return {
    codigo,
    // El original mostraba y registraba el código incompleto como si fuera válido.
    truncado,
    detalle: {
      fechaDocumento: fecha,
      sucursalId: Sucursal,
      cliente: Cliente,
      tipoDocumento: Documento,
      importe: Importe,
    },
  };
}
